import { IMerchant } from "constants/merchants";
import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { MERCHANT_ADMIN_ACCOUNT } from "../constants/action-types";
import { progressActions } from "./base-reducers";

interface IBaseState<T> {
    payload: T;
    error?: { message: string };
}

export interface IMerchantState extends IBaseState<IMerchant> {
    isFetching: false;
}

export interface IMerchantAdminAccountState {
    merchant: IMerchantState;
}

export const merchantAdminAccount = combineReducers<IMerchantAdminAccountState>({
    merchant: handleActions(
        {
            ...progressActions(MERCHANT_ADMIN_ACCOUNT.MERCHANT.FETCH, "isFetching"),
        } as any,
        null,
    ),
});
